import React from "react";

import moment from "moment";

import NumberFormat from "react-number-format";

import QRCode from "react-qr-code";

import toast from "react-hot-toast";

import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconProp } from "@fortawesome/fontawesome-svg-core";

const idLocale = require('moment/locale/id')
moment.updateLocale('id', idLocale);

interface QrisProps {
	data: {
		admin: number;
		channel: string;
		displayName: string;
		expired: string;
		fee: number;
		nominal: number;
		totalBayar: number;
		va: string;
	};
}

const Qris: React.FC<QrisProps> = ({ data }): JSX.Element => {
	const {
		admin,
		displayName,
		expired,
		nominal,
		totalBayar: totalPrice,
		va,
	} = data;

	return (
		<div className="w-full">
			<div className="flex justify-center sm:text-3xl font-medium my-4">
				<span className="font-inter font-semibold text-lg sm:text-2xl text-gray-800">QRIS</span>
			</div>
			<div className="flex justify-center mt-1 mb-4">
				<QRCode size={200} value={va} />
			</div>
			<div className="text-base font-dmsans text-gray-800 mt-1 mb-4">
				<span>Scan QRCode Ini Untuk Melakukan Pembayaran</span>
			</div>
			<div
				className="copy cursor-pointer mb-5"
				data-clipboard-text={totalPrice}
				onClick={(): void => {
					toast.success(`Nominal Berhasil Di Salin`, {
						style: {
							fontWeight: "bolder",
						},
					});
				}}>
				<NumberFormat
					value={totalPrice}
					className="font-inter font-extrabold text-lg sm:text-2xl 2xl:text-3xl text-gray-800 cursor-pointer"
					displayType={"text"}
					thousandSeparator={"."}
					decimalSeparator={","}
					prefix={"Rp "}
				/>
				<div>
					<span className="text-xs text-gray-500 font-dmsans tracking-wider">
						KETUK UNTUK MENYALIN NOMINAL
					</span>
				</div>
			</div>
			<div className="p-3 bg-white shadow-lg rounded-md">
				{/* DEPOSIT INFORMATION */}
				<div className="flex justify-between p-2">
					<div>
						<span className="text-sm sm:text-lg font-medium font-dmsans">Informasi Deposit</span>
					</div>
					<div>
						<FontAwesomeIcon icon={faInfoCircle as IconProp}></FontAwesomeIcon>
					</div>
				</div>
				<hr />

				{/* NAME */}
				<div className="flex justify-between px-2 py-1 lg:p-2 text-left">
					<div>
						<span className="text-xs sm:text-base text-gray-500 font-dmsans">Nama</span>
					</div>
					<div className="text-left">
						<span className="text-xs sm:text-base font-medium font-dmsans">
							{displayName}
						</span>
					</div>
				</div>

				{/* EXPIRED TIME */}
				<div className="flex justify-between px-2 py-1 lg:p-2 text-left">
					<div>
						<span className="text-xs sm:text-base text-gray-500 font-dmsans">Kadaluarsa</span>
					</div>
					<div className="text-left">
						<span className="text-xs sm:text-base font-medium font-dmsans">{moment.utc(expired).format("DD MMMM YYYY HH:mm:ss")} WIB</span>
					</div>
				</div>

				{/* NOMINAL */}
				<div className="flex justify-between px-2 py-1 lg:p-2 text-left">
					<div>
						<span className="text-xs sm:text-base text-gray-500 font-dmsans">Nominal</span>
					</div>
					<div className="flex gap-2">
						<NumberFormat
							value={nominal}
							className="text-xs sm:text-base font-medium font-dmsans"
							displayType={"text"}
							thousandSeparator={"."}
							decimalSeparator={","}
							prefix={"Rp "}
						/>
					</div>
				</div>

				{/* ADMIN PRICE */}
				<div className="flex justify-between px-2 py-1 lg:p-2 text-left">
					<div>
						<span className="text-xs sm:text-base text-gray-500 font-dmsans">Admin</span>
					</div>
					<div className="flex gap-2">
						<NumberFormat
							value={admin}
							className="text-xs sm:text-base font-medium font-dmsans"
							displayType={"text"}
							thousandSeparator={"."}
							decimalSeparator={","}
							prefix={"Rp "}
						/>
					</div>
				</div>

				{/* TOTAL PRICE */}
				<div className="flex justify-between px-2 py-1 lg:p-2 text-left">
					<div>
						<span className="text-xs sm:text-base text-gray-500 font-dmsans">Total</span>
					</div>
					<div className="flex gap-2">
						<NumberFormat
							value={totalPrice}
							className="text-xs sm:text-base font-medium font-dmsans"
							displayType={"text"}
							thousandSeparator={"."}
							decimalSeparator={","}
							prefix={"Rp "}
						/>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Qris;
